<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Back') }}
    </b-button>
    <div class="dp02 p-3 mt-3">
      <div class="text-center col-lg-12">
        <h2>{{ $t('results.Viewing') }} {{ $moment(uploadedAt).format('DD.MM.YYYY HH:mm:ss') }}</h2>
      </div>
      <div class="row">
        <div class="col-8 offset-2 mt-1 text-center">
          <div class="row">
            <div class="col-12 text-center">
              <div class="row my-3">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('results.status') }}:</label>
                </div>
                <div class="col-lg-9">
                  <StatusDisplay :status="status" />
                </div>
              </div>
              <div class="row my-3">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('results.paired') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-textarea
                    class="myInput"
                    :disabled="true"
                    no-resize
                    size="sm"
                    rows="7"
                    v-model="paired" />
                </div>
              </div>
              <div class="row my-3">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('results.unpairable') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-textarea
                    class="myInput"
                    :disabled="true"
                    no-resize
                    size="sm"
                    rows="7"
                    v-model="unpairable" />
                </div>
              </div>
              <div class="row my-3">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('results.generated') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-textarea
                    class="myInput"
                    :disabled="true"
                    no-resize
                    size="sm"
                    rows="7"
                    v-model="generated" />
                </div>
              </div>
              <div class="row my-3">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('results.toBeGenerated') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-textarea
                    class="myInput"
                    :disabled="true"
                    no-resize
                    size="sm"
                    rows="7"
                    v-model="toBeGenerated" />
                </div>
              </div>
              <div v-if="exception !== null"
                   class="row my-3">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('results.exception') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-textarea
                    class="myInput"
                    :disabled="true"
                    no-resize
                    size="sm"
                    rows="7"
                    v-model="exception" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import StatusDisplay from '@components/admin/results/StatusDisplay';

export default {
  name: 'ViewResultDetail',
  components: {
    StatusDisplay
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewResultDetail', ['status', 'paired', 'unpairable', 'generated', 'toBeGenerated', 'uploadedAt', 'exception'])
  },
  data() {
    return {
      cancelRefresh: false
    };
  },
  created() {
    this.resetContext();
    this.setResultId(Number(this.id));
    this.fetchResult();
    this.refresh();
  },
  beforeDestroy() {
    this.cancelRefresh = true;
  },
  methods: {
    ...mapMutations({
      setResultId: 'viewResultDetail/setResultId'
    }),
    ...mapActions({ resetContext: 'viewResultDetail/resetContext',
      fetchResult: 'viewResultDetail/fetchResult' }),
    refresh() {
      if (!this.cancelRefresh) {
        this.fetchResult();
        setTimeout(this.refresh, 3000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
